import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-text-display-modal',
  templateUrl: './text-display-modal.component.html',
  styleUrls: ['./text-display-modal.component.css']
})

export class TextDisplayModalComponent {
  @Input() headerText: string | null
  @Input() labelText: string | null
  @Input() bodyText: string
  @Input() buttonText: string = 'Close'

  constructor(
    private ngbActiveModal: NgbActiveModal
  ) { }

  closeModal () {
    this.ngbActiveModal.close()
  }
}
